module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    staticClass: "login-container",
    attrs: {
      "label-position": "left",
      "label-width": "0px"
    }
  }, [_c('div', {
    staticClass: "express-form-wrap"
  }, [_c('h3', {
    staticClass: "guild-name"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("公会名：" + _vm._s(_vm.clubName))])]), _vm._v(" "), (!_vm.success) ? _c('div', {
    staticClass: "form-wrap"
  }, [(_vm.clubSharedRatio.length > 0) ? _c('div', [(_vm.nickname) ? _c('div', {
    staticClass: "info-wrap mr-20"
  }, [_c('div', {
    staticClass: "anchor-info"
  }, [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": ("https:" + _vm.icon),
      "alt": "主播头像"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "anchor-room"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('span', {
    staticClass: "lable"
  }, [_vm._v("昵称：")]), _vm._v(_vm._s(_vm.nickname) + "\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [(_vm.roomid <= 0) ? _c('div', {
    staticClass: "tips-title"
  }, [_vm._v("您还不是主播~")]) : _c('div', {
    staticClass: "tips-title2"
  }, [_vm._v("房间号: " + _vm._s(_vm.roomid))]), _vm._v(" "), _c('div', {
    staticClass: "tips-txt"
  }, [_vm._v("请确保提交申请后24小时完成实名认证，否则申请无效")])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "info-wrap"
  }, [_c('div', {
    staticClass: "sign-info"
  }, [_c('h2', {
    staticClass: "sign-info-title"
  }, [_vm._v("您确定与该公会签约吗？")]), _vm._v(" "), _c('div', {
    staticClass: "guild-sign"
  }, [_c('img', {
    staticClass: "guild-avatar",
    attrs: {
      "src": _vm.guild_badge_image,
      "alt": "公会头像"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "guild-sign-info"
  }, [_c('table', [_c('tbody', [_c('tr', {
    staticClass: "sign-info-row"
  }, [_c('td', {
    staticClass: "opt-name"
  }, [_vm._v("签约公会：")]), _vm._v(" "), _c('td', {
    staticClass: "opt-desc"
  }, [_c('span', {
    staticClass: "sign-guild-name",
    attrs: {
      "title": _vm.guild_name
    }
  }, [_vm._v(_vm._s(_vm.guild_name))])])]), _vm._v(" "), _c('tr', {
    staticClass: "sign-info-row"
  }, [_c('td', {
    staticClass: "opt-name"
  }, [_vm._v("签约时长：")]), _vm._v(" "), _c('td', {
    staticClass: "opt-desc"
  }, [_c('el-select', {
    model: {
      value: (_vm.selectIndex),
      callback: function($$v) {
        _vm.selectIndex = $$v
      },
      expression: "selectIndex"
    }
  }, _vm._l((_vm.clubSharedRatio), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.desc,
        "value": index
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('tr', {
    staticClass: "sign-info-row"
  }, [_c('td', {
    staticClass: "opt-name"
  }, [_vm._v("主播礼物提成：")]), _vm._v(" "), _c('td', {
    staticClass: "opt-desc"
  }, [_c('span', {
    staticClass: "ratio",
    attrs: {
      "id": "anchor-ratio"
    }
  }, [_vm._v(_vm._s(100 - _vm.clubSharedRatio[_vm.selectIndex].ratio) + "%")])]), _vm._v(" "), _c('td', {
    staticClass: "opt-name"
  }, [_vm._v("礼物收益结算：")]), _vm._v(" "), _c('td', {
    staticClass: "opt-desc"
  }, [_vm._v(_vm._s(_vm.settle_type === 1 ? "对公结算" : '对私结算'))])]), _vm._v(" "), _c('tr', {
    staticClass: "sign-info-row"
  }, [_c('td', {
    staticClass: "opt-name"
  }, [_vm._v("主播陪玩提成：")]), _vm._v(" "), _c('td', {
    staticClass: "opt-desc"
  }, [_c('span', {
    staticClass: "ratio",
    attrs: {
      "id": "anchor-pw-ratio"
    }
  }, [_vm._v(_vm._s(100 - _vm.clubSharedRatio[_vm.selectIndex].pwRatio) + "%")])]), _vm._v(" "), _c('td', {
    staticClass: "opt-name"
  }, [_vm._v("陪玩订单结算：")]), _vm._v(" "), _c('td', {
    staticClass: "opt-desc"
  }, [_vm._v(_vm._s(_vm.settle_type_pw === 1 ? "对公结算" : '对私结算'))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "guild-desc"
  }, [_c('p', {
    staticClass: "guild-desc-row"
  }, [_c('span', {
    staticClass: "desc-name"
  }, [_vm._v("对公结算：")]), _vm._v(" "), _c('span', {
    staticClass: "desc-remark"
  }, [_vm._v("主播收益在结算时，全部计入签约公会的对公账户，由公会统一代为扣税后再分配给主播。")])]), _vm._v(" "), _c('p', {
    staticClass: "guild-desc-row"
  }, [_c('span', {
    staticClass: "desc-name"
  }, [_vm._v("对私结算：")]), _vm._v(" "), _c('span', {
    staticClass: "desc-remark"
  }, [_vm._v("主播收益在结算时，按公会抽成比例分别计算主播和公会所得，主播所得计入主播的个人账户，提现时将扣除相关费用。")])]), _vm._v(" "), _c('p', {
    staticClass: "guild-desc-row"
  }, [_c('span', {
    staticClass: "desc-name attention"
  }, [_vm._v("注意：")]), _vm._v(" "), _c('span', {
    staticClass: "desc-remark"
  }, [_vm._v("与公会签约期间，严禁您使用其他帐号进行表演。一旦发现，官方有权禁止此帐号在斗鱼平台进行表演。")])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "rowwrap"
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "400px",
      "margin-left": "40px"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入手机号码",
      "clearable": ""
    },
    on: {
      "input": _vm.onChanged,
      "clear": function($event) {
        this.mobile = ''
      }
    },
    model: {
      value: (_vm.mobile),
      callback: function($$v) {
        _vm.mobile = $$v
      },
      expression: "mobile"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "400px",
      "margin-left": "40px"
    }
  }, [_c('el-input', {
    attrs: {
      "oninput": "if(value.length > 6) value = value.slice(0, 6)",
      "placeholder": "请输入验证码"
    },
    model: {
      value: (_vm.code),
      callback: function($$v) {
        _vm.code = _vm._n($$v)
      },
      expression: "code"
    }
  }, [_c('template', {
    slot: "append"
  }, [_c('el-button', {
    class: _vm.isMobile ? 'enableButton' : 'disableButton',
    staticStyle: {
      "width": "102px"
    },
    attrs: {
      "disabled": !_vm.isMobile || this.timeHandler > 0
    },
    on: {
      "click": _vm.handleGetCode
    }
  }, [_vm._v(_vm._s(this.timeHandler > 0 ? this.countDown : '获取验证码'))])], 1)], 2)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "rowwrap protocal-wrap"
  }, [_c('el-checkbox', {
    staticStyle: {
      "margin-right": "2px"
    },
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "protocol",
      "id": "protocal-label"
    }
  }, [_c('p', {
    staticClass: "protocal-text"
  }, [_c('span', [_vm._v("我已阅读且同意")]), _c('a', {
    attrs: {
      "href": "//www.douyu.com/protocal/roomclub",
      "target": "_blank"
    }
  }, [_vm._v("斗鱼公会主播入驻服务协议")]), _vm._v("、"), _c('a', {
    attrs: {
      "href": "//www.douyu.com/cms/zhibo/201907/30/6261.shtml",
      "target": "_blank"
    }
  }, [_vm._v("公会主播疑难解答")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "rowwrap foot-wrap"
  }, [_c('el-button', {
    class: !_vm.checked || ("" + _vm.code).length < 6 || _vm.loading || !_vm.send_sms ? 'disableButton' : 'enableButton',
    staticStyle: {
      "width": "420px",
      "height": "40px"
    },
    attrs: {
      "loading": _vm.loading,
      "disabled": !_vm.checked || ("" + _vm.code).length < 6 || _vm.loading || !_vm.send_sms
    },
    on: {
      "click": _vm.joinClub
    }
  }, [_vm._v("加入公会")])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "foot-tips"
  }, [_vm._v("温馨提示：请确保在提交申请后24小时内完成实名认证，否则申请无效")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-082d9fb6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Invite.vue
// module id = 228
// module chunks = 1